import React, { useState } from 'react';
import StaffLogin from './StaffLogin';
import AdminPanel from '../../../Core/Admin/AdminPanel';
// import SpecialistConsole from './SpecialistConsole'; // Keeping for reference but unused per new requirement


/**
 * StaffAdmin - Wrapper to manage Login -> Console transition
 */
const StaffAdmin = ({ ipserv }) => {
    // Initial state from localStorage to persist session on refresh
    const [auth, setAuth] = useState(() => {
        const saved = localStorage.getItem('turnero_staff_session');
        return saved ? JSON.parse(saved) : {
            isLoggedIn: false,
            user: null,
            typeId: null,
            sucursalId: null,
            specialistId: null
        };
    });

    const handleLoginSuccess = (response) => {
        const { user, token } = response;
        const newAuth = {
            isLoggedIn: true,
            user,
            typeId: user.TipoAsociado,
            sucursalId: user.SucursalId,
            specialistId: user.EspecialistaId 
        };
        setAuth(newAuth);
        localStorage.setItem('turnero_staff_session', JSON.stringify(newAuth));
        localStorage.setItem('dm_auth_token', token);
        // We also set dm_admin to "trick" the routing, but marking it as role STAFF
        localStorage.setItem('dm_admin', JSON.stringify({
            ...user,
            AdminId: user.AdminId,
            EmpresaId: user.EmpresaId, // Ensure EmpresaId is kept
            SucursalId: user.SucursalId,
            AdminNombre: user.UsrNombre,
            AdminApellido: user.UsrApellido,
            AdminEmail: user.UsrDni, 
            AdminRole: 'STAFF',
            ProfileId: user.ProfileId
        }));
    };

    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
    };

    if (!auth.isLoggedIn) {
        return <StaffLogin ipserv={ipserv} onLoginSuccess={handleLoginSuccess} />;
    }

    // Staff defaults to the Reporting Panel (AdminPanel)
    return (
        <AdminPanel 
            ipserv={ipserv} 
        />
    );
};

export default StaffAdmin;
